// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfh_a bhg_wh bhg_sq bhg_xj"};